import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { I18nContext } from './I18nContext';
var TIME_AGO_INTERVAL = 10000;

var mapJavaLocalesToISO639 = function mapJavaLocalesToISO639(locale) {
  switch (locale) {
    case 'in':
    case 'in-ID':
      return 'id';

    case 'iw':
    case 'iw-IL':
      return 'he';

    case 'no':
    case 'no-NO':
      return 'nb';

    case 'no-NO-NY':
      return 'nn';

    case 'zh':
    case 'zh-SG':
      return 'zh-cn';

    default:
      return locale;
  }
};

export var importLocale = function importLocale(locale, success) {
  var code = mapJavaLocalesToISO639(locale);

  if (!code || code === 'en') {
    moment.locale(code);

    if (typeof success === 'function') {
      success();
    }
  } else {
    import("moment/locale/".concat(code))["catch"](function (error) {
      var localeAncestor = code.match(/(.+)-..$/);

      if (localeAncestor && localeAncestor[1]) {
        importLocale(localeAncestor[1], success);
      } else {
        console.warn('Locale could not be found.', error);
      }
    }).then(function () {
      moment.locale(code);

      if (typeof success === 'function') {
        success();
      }
    });
  }
};

var MomentComponent = /*#__PURE__*/function (_Component) {
  _inherits(MomentComponent, _Component);

  var _super = _createSuper(MomentComponent);

  function MomentComponent(props) {
    var _this;

    _classCallCheck(this, MomentComponent);

    _this = _super.call(this, props);
    _this.state = {};
    _this.tick = _this.tick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MomentComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      importLocale(this.props.locale, function () {
        return _this2.setState({
          locale: _this2.props.locale
        });
      });

      if (this.props.fromNow) {
        this.interval = setInterval(this.tick, TIME_AGO_INTERVAL);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (this.props.locale && this.props.locale !== prevProps.locale) {
        importLocale(this.props.locale, function () {
          return _this3.setState({
            locale: _this3.props.locale
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "tick",
    value: function tick() {
      this.setState(this.state);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.locale) {
        if (this.state.locale) {
          if (typeof this.props.render === 'function') {
            return this.props.render(format(this.state.locale), this.state.locale);
          } else {
            return format(this.state.locale)(this.props.timestamp, this.props.format);
          }
        } else {
          // If locale language is not yet loaded, don't render anything
          return null;
        }
      } else {
        // If locale is not set at app level, return without localizing
        return format()(this.props.timestamp, this.props.format);
      }
    }
  }]);

  return MomentComponent;
}(Component);

var format = function format(locale) {
  return function (timestamp, format) {
    var formatFn = format === 'fromNow' ? function (m) {
      return m.fromNow();
    } : function (m) {
      return m.format(format ? Moment.formats[format] || format : Moment.formats.dateTime);
    };

    if (locale) {
      return formatFn(moment(timestamp).locale(locale));
    } else {
      return formatFn(moment(timestamp));
    }
  };
};

export var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: state.app.config.locale
  };
};
export var Moment = function Moment(props) {
  return /*#__PURE__*/React.createElement(I18nContext.Consumer, null, function (_ref) {
    var locale = _ref.locale;
    return /*#__PURE__*/React.createElement(MomentComponent, Object.assign({
      locale: locale
    }, props));
  });
};
connect(mapStateToProps)(MomentComponent);
Moment.formats = {
  time: 'LT',
  timeWithSeconds: 'LTS',
  date: 'LL',
  dateWithDay: 'dddd, LL',
  dateNumeric: 'L',
  dateShort: 'll',
  dateWithDayShort: 'ddd, ll',
  dateTime: 'LLL',
  dateTimeNumeric: 'L LT',
  dateTimeShort: 'lll',
  dateTimeWithDay: 'LLLL',
  dateTimeWithDayShort: 'llll'
};